// extracted by mini-css-extract-plugin
export var content = "_pw-1";
export var fullScreen = "_pw-0";